/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiParameter
 */
export interface ApiParameter {
  /**
   *
   * @type {string}
   * @memberof ApiParameter
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiParameter
   */
  value?: string;
}

/**
 * Check if a given object implements the ApiParameter interface.
 */
export function instanceOfApiParameter(value: object): value is ApiParameter {
  return true;
}

export function ApiParameterFromJSON(json: any): ApiParameter {
  return ApiParameterFromJSONTyped(json, false);
}

export function ApiParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiParameter {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    value: json['value'] == null ? undefined : json['value'],
  };
}

export function ApiParameterToJSON(json: any): ApiParameter {
  return ApiParameterToJSONTyped(json, false);
}

export function ApiParameterToJSONTyped(
  value?: ApiParameter | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    value: value['value'],
  };
}
